import { useFilters } from '@statsbomb/kitbag-global-football';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { teamIdAtom } from '@/atoms/team/team';
import { METRIC_KEY } from '@/consts/searchKeys';
import { useSetTeamDataDebouncedFilterParams } from '@/hooks/apiFilterParams/useSetTeamDataDebounceFilterParams';
import TeamPreview from '@/pages/team/preview/TeamPreview';

export const TeamDataLockerPreview = () => {
  useSetTeamDataDebouncedFilterParams();
  const [searchParams] = useSearchParams();
  const metricKey = searchParams.get(METRIC_KEY);
  const teamId = searchParams.get('teamId');

  const [filters, setFilters] = useFilters('main');
  const setTeamId = useSetAtom(teamIdAtom);

  useEffect(() => {
    if (metricKey && teamId) {
      setFilters({ ...filters, metric: metricKey });
      setTeamId(Number(teamId));
    }
  }, [metricKey, teamId]);

  if (!teamId || !metricKey) return null;

  return <TeamPreview />;
};
